import { message, Modal, Tag } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { FaPhone } from "react-icons/fa";
import { FcAssistant } from "react-icons/fc";
import { SlCallEnd } from "react-icons/sl";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

import SearchContext from "../../../Context/SearchContext";
import ReactAudioPlayer from "react-audio-player";

var timeout = null;

const Call = ({ row, saveData }) => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
  } = useSpeechRecognition();

  const { user, isHome, setActive } = useContext(SearchContext);
  const [isCall, setIsCall] = useState(false);
  const [time, setTime] = useState(0);
  const [myVoice, setMyVoice] = useState();
  const [created, setCreated] = useState();
  const [loading, setLoading] = useState(0);

  const myTimeout = setTimeout(() => {
    if (isCall) {
      setTime(time + 1);
    } else {
      setTime(0);
    }
  }, 1000);

  useEffect(() => {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      SpeechRecognition.abortListening();
    }, 2000);
  }, [transcript]);

  useEffect(() => {
    checkVoice();
    if (transcript !== "close") {
      if (!listening && transcript.length) {
        resetTranscript();
        let snd = new Audio(
          "data:audio/wav;base64,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"
        );
        snd.play();
        setLoading(true);
        setCreated()
        handleSubmit();

      }
      if (!listening && isCall && transcript.length === 0) {
        SpeechRecognition.startListening();
      }
    } else {
      closeModal();
    }
  }, [listening]);

  const checkVoice = () => {
    const voices = speechSynthesis.getVoices();
    if (voices.length && myVoice === undefined) {
      for (let i = 0; i < voices.length; i++) {
        if (voices[i].name === "Google UK English Female") {
          setMyVoice(voices[i]);
        }
      }
    }
  };

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }
  const findTimeStamp = (q) => {
    let a = q;
    const i = a.indexOf(":");
    if (i !== -1 && a.slice(i + 3, i + 4) === ":") {
      return a.slice(i - 2, i + 6);
    }
  };

  const handleSubmit = () => {
    const obj = {
      query: transcript.trim(),
      roleplay_id: window.location.pathname.slice(1),
      voice: true,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify(obj),
    };
    fetch(`https://embed.axv.ai/api/vector/dialogue`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        const msg = new SpeechSynthesisUtterance();

        msg.voice = myVoice;
        if (data && data._id) {
          saveData(data);

          // msg.text = data.response;
          setCreated(data);
        } else {
          msg.text = "Something weng wrong";
        }

        let r = setInterval(() => {
          if (!speechSynthesis.speaking) {
            clearInterval(r);
          } else {
            speechSynthesis.pause();
            speechSynthesis.resume();
          }
        }, 10000);
      });
  };

  const closeModal = () => {
    const msg = new SpeechSynthesisUtterance();
    msg.voice = myVoice;
    let text = user ? `Take care ${user.name}, Bye` : `Take care, Bye`;

    msg.text = text;
    resetTranscript();
    setCreated();
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(msg);

    SpeechRecognition.stopListening();
    setTime(0);
    clearTimeout(myTimeout);
    setIsCall(false);
  };
  const startCall = (v) => {
    const msg = new SpeechSynthesisUtterance();
    msg.voice = myVoice;
    msg.text = v;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(msg);
    console.log("started");
  };
  const TimeCorrection = (number) => {
    let hours = number / 3600;
    hours = Math.floor(hours);

    let remainder = number % 3600;
    let minuts = remainder / 60;
    minuts = Math.floor(minuts);

    remainder = remainder % 60;
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minuts < 10) {
      minuts = "0" + minuts;
    }
    if (remainder < 10) {
      remainder = "0" + remainder;
    }

    return hours + ":" + minuts + ":" + remainder;
  };
  return (
    <div className={` `}>
      {isCall ? (
        <div className="cell-call-img-ac">
          <div className="cell-call-img-ac2">
            <div class="content-center">
              <div onClick={closeModal} class="pulse">
                <Tag color="rgb(205, 1, 1)">
                  {" "}
                  <SlCallEnd />
                </Tag>
                {listening ? "Listening" : "Speaking"}
              </div>
            </div>
            <p>{transcript}</p>

            <p></p>

            <h5>Calling...{TimeCorrection(time)}</h5>
          </div>

          {created ? (
            <div className="audio-hidden-c">
              <ReactAudioPlayer
                onEnded={() => SpeechRecognition.startListening()}
                autoPlay
                src={created.voice_url}
                controls
              />
            </div>
          ) : null}
        </div>
      ) : (
        <FaPhone
          onClick={() => {
            setIsCall(true);

            // SpeechRecognition.stopListening();
            SpeechRecognition.startListening();
          }}
          className={`call-icon-c`}
        />
      )}
    </div>
  );
};
export default Call;
